<template>
    <div class="cost-complete">
      <van-nav-bar title="提交完成" />
      
      <div class="complete-content">
        <van-icon name="success" class="success-icon" />
        <h2 class="complete-title">提交成功</h2>
        <p class="complete-desc">您的费用申请已提交成功</p>
        
        <div class="button-group">
          <!-- <van-button 
            round 
            block 
            type="primary" 
            class="action-button"
            @click="goToList"
          >
            查看申请记录
          </van-button> -->
          
          <van-button 
            round 
            block 
            plain 
            type="primary" 
            class="action-button"
            @click="goToNew"
          >
            继续提交
          </van-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CostComplete',
    methods: {
      goToList() {
        this.$router.push('/costs/list')
      },
      goToNew() {
        this.$router.push('/costs/add')
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .cost-complete {
    min-height: 100vh;
    background-color: #f7f8fa;
  
    .complete-content {
      padding: 40px 20px;
      text-align: center;
  
      .success-icon {
        font-size: 60px;
        color: #07c160;
      }
  
      .complete-title {
        margin: 20px 0 10px;
        font-size: 20px;
        color: #323233;
      }
  
      .complete-desc {
        margin: 0 0 30px;
        color: #969799;
        font-size: 14px;
      }
  
      .button-group {
        padding: 0 16px;
  
        .action-button {
          margin-bottom: 12px;
        }
      }
    }
  }
  </style>